<script setup>
import PlusBoldIcon from "@/components/Icons/PlusBoldIcon.vue";
import { computed, ref, defineProps, defineEmits } from "vue";
import { t } from "@/controllerLK/AvalLocalization";

const props = defineProps({
  sourceList: {
    type: Array,
    required: true,
  },
  isNewSourceCreating: {
    type: Boolean,
    required: true,
    default: false
  },
  activeSource: {
    type: [Object, null],
    required: true,
  }
});

const emit = defineEmits(["add-source", "handle-select-source", "update-active-source-name"]);

const activeSourceName = computed({
  get() { return props.activeSource.name; },
  set(value) { emit("update-active-source-name", value); }
});

const sourceSearchQuery = ref("");

// Фильтрация по строке запроса
const filteredSources = computed(() => {
  const q = sourceSearchQuery.value.trim().toLowerCase();
  if (!q) return props.sourceList;
  return props.sourceList.filter(src =>
    src.name?.toLowerCase().includes(q)
  );
});
</script>

<template>
  <div class="source-view">
    <div class="source-view__header">
      <div class="source-view__search">
        <AvalInputSearchSecondary
          v-model="sourceSearchQuery"
          :placeholder="t(`source_list.placeholder.search`)"
        />
      </div>
      <AvalButtonIconAccentSecondary
        class="source-view__create"
        @click="emit('add-source')"
      >
        <PlusBoldIcon />
      </AvalButtonIconAccentSecondary>
    </div>
    <div class="source-view__body scroll">
      <div class="source-view__list">
        <input
          v-if="isNewSourceCreating"
          v-model="activeSourceName"
          type="text"
          class="source-view__list-input"
        >
        <div
          v-for="source in filteredSources"
          :key="source.id"
          class="source-view__list-item"
          :class="{'source-view__list-item--active': source.id === activeSource?.id}"
          @click="emit('handle-select-source', source)"
        >
          {{ source.name }}
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped lang="scss">
.source-view {
  display: flex;
  flex-direction: column;
  background: var(--background-bg-white);
  border-radius: 8px;
  padding: 24px;
  gap: 20px;
  min-height: 0;

  &__list {
    display: flex;
    flex-direction: column;
    gap: 2px;
    overflow: auto;
    min-height: 0;
    padding-right: 5px;

    &-input {
      width: 100%;
      height: 42px;
      padding: 16px;
      background: #E0F0FF;
      border-radius: 8px;
    }

    &-item {
      align-items: center;
      display: inline;
      text-overflow: ellipsis;
      overflow: hidden;
      padding: 16px;
      height: 42px;
      color: var(--text-text-on);
      border-radius: 8px;
      cursor: pointer;
      white-space: nowrap;

      &--active {
        background: var(--background-bg-active-hover);
      }

      &:hover:not(&--active) {
        background: var(--background-bg-hover);
      }
    }
  }

  &__create {
    display: flex;
    justify-content: center;
    align-items: center;
    background: var(--background-01);
    border-radius: 50px;
    min-width: 36px;
    height: 36px;
    cursor: pointer;
    user-select: none;

    &:hover {
      background: var(--background-bg-hover);
    }

    &-icon {
      color: var(--button-secondary-accent-hover-icon);
    }
  }

  &__search {
    display: flex;
    align-items: center;
    justify-content: center;
    position: relative;
    background: var(--background-01);
    border-radius: 8px;
    height: 36px;
    margin-right: 20px;

    &-input {
      background: var(--background-01);
    }

    &-icon {
      position: absolute;
      right: 10px;
      color: var(--icon-icon-secondary);
    }
  }

  &__header {
    display: flex;
    justify-content: space-between;
  }

  &__body {
    flex: 1;
  }

}
</style>